import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAtom } from 'jotai';
import { imageUrlToDisplayState } from '../../state/chat/ImageUrlToDisplayState';
import { useAppTranslation } from '../../hooks/useAppTranslation';

export function ShowImageDialog() {
    const [imageUrl, setImageUrl] = useAtom(imageUrlToDisplayState);
    const { t } = useAppTranslation();

    function handleClose() {
        setImageUrl(null);
    }

    return (
        <Dialog
            open={imageUrl != null}
            onClose={handleClose}
            maxWidth='md'
            fullWidth
            aria-labelledby='chat-image-preview-title'
            PaperProps={{
                sx: {
                    backgroundColor: 'var(--component-bg)',
                    color: 'var(--text-color)',
                    border: '1px solid var(--border-color)',
                    borderRadius: 3,
                    boxShadow: '0 24px 52px rgba(15, 23, 42, 0.22)',
                    overflow: 'hidden',
                },
            }}
        >
            <DialogTitle
                id='chat-image-preview-title'
                sx={{
                    pr: 6,
                    backgroundColor: 'var(--component-bg)',
                    color: 'var(--text-color)',
                    borderBottom: '1px solid var(--border-color)',
                }}
            >
                {t.imagePreviewTitle}
                <IconButton
                    aria-label={t.close}
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'var(--text-color)',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    backgroundColor: 'var(--component-bg)',
                    borderColor: 'var(--border-color)',
                    p: 2,
                }}
            >
                {imageUrl && (
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 2,
                            overflow: 'hidden',
                            backgroundColor: 'var(--component-bg-light)',
                            border: '1px solid var(--border-color)',
                            minHeight: 240,
                            maxHeight: '70vh',
                        }}
                    >
                        <img
                            src={imageUrl}
                            alt={t.imagePreviewAlt}
                            style={{ width: '100%', height: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                        />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
